// extracted by extract-css-chunks-webpack-plugin
module.exports = {"theme":"#ff7802"};